import { render } from "./usp.vue?vue&type=template&id=d736cc72"
import script from "./usp.vue?vue&type=script&lang=js"
export * from "./usp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__